module.exports = __webpack_public_path__ + "static/media/Autobiz_logo.55a605fa.png";